<template>
<v-container id="grid" fluid tag="section">
  <div class="page-shell">
    <notification-dialog/>
    <filter-form-outcome/>
    <dialog-form-outcome/>
    <v-card class="page-card">
      <v-toolbar color="primary" class="page-toolbar">
        <v-toolbar-title>Salidas</v-toolbar-title>
        <v-btn v-if="canCreate" color="white" variant="flat" class="toolbar-add-button" @click="addOutcome()">Agregar Salida</v-btn>
      </v-toolbar>
      <div class="table-wrapper">
        <table-outcome/>
      </div>
    </v-card>
  </div>
</v-container>
</template>
<script>
import FilterOutcomeForm from './FilterOutcomeForm'
import AddEditOutcomeForm from './AddEditOutcomeForm'
import OutcomeTable from './OutcomeTable'
import NotificationDialog from '../Common/NotificationDialog'

export default {
  name: 'Outcome',
  components: {
    'filter-form-outcome': FilterOutcomeForm,
    'dialog-form-outcome': AddEditOutcomeForm,
    'table-outcome': OutcomeTable,
    'notification-dialog': NotificationDialog
  },

  data: () => ({
    successMsg: ''
  }),
  computed: {
    canCreate () { return this.$store.getters['authModule/hasPermission']('plant.outcomes.create') }
  },

  created () {
    this.$store.dispatch('locationModule/getBaseLocations')
    this.$store.dispatch('companyModule/getBaseCompanies')
    this.$store.dispatch('typesModule/getPackagingTypes')
    this.$store.dispatch('typesModule/getGrainTypes')
    this.$store.dispatch('processModule/getProcesses')
  },

  beforeUnmount () {
    this.$store.commit('processModule/resetState')
  },

  methods: {
    addOutcome () {
      this.$store.dispatch('outcomeModule/setDialogActived', true)
    }
  }
}
</script>
